import { Usage } from './usage';

export class MetadataDetails {
    constructor(
        public dateCreated?: string,
        public deletable?: boolean,
        public editable?: boolean,
        public editableFields?: string[],
        public lastModified?: string,
        public usage?: Usage
    ) {
    }
}
